module.exports = __webpack_public_path__ + "img/Umb43_uv_logoside_1083.8dd4ffc8.svg";